/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_DownloadedInputs */



/**
* | output |
* | --- |
* | "Preview thumbnail downloaded successfully" |
*
* @param {Video_Export_Preview_DownloadedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_downloaded = /** @type {((inputs?: Video_Export_Preview_DownloadedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_DownloadedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Miniature de previsualisation telechargee avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschaubild erfolgreich heruntergeladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima miniatura scaricata correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр миниатюры успешно загружен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa en miniatura descargada exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预览缩略图已成功下载")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレビューサムネイルが正常にダウンロードされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्वावलोकन थंबनेल सफलतापूर्वक डाउनलोड हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Miniatura de pré-visualização baixada com sucesso.")
	return /** @type {LocalizedString} */ ("Preview thumbnail downloaded successfully")
});